import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { DepartmentPickerItem } from '@data-managment/department-picker/shared/department-picker-item';
import { EstimateConfiguration } from '@interfaces/EstimateConfiguration';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { LoadingService } from '@shared/services/loading.service';
import { DepartmentPickerService } from '../department-picker/shared/department-picker.service';

@Component({
  selector: 'pop-default-department-selector',
  templateUrl: './default-department-selector.component.html',
  styleUrls: ['./default-department-selector.component.less']
})
export class DefaultDepartmentSelectorComponent extends BaseComponent implements OnInit {
  public selectedDepartment?: DepartmentPickerItem;
  private estimateSettings?: EstimateConfiguration;

  public constructor(
    private estimateSettingsService: EstimateSettingsService,

    private loadingService: LoadingService,
    private departmentPickerService: DepartmentPickerService
  ) {
    super();
  }

  public async ngOnInit() {
    this.estimateSettings = await this.estimateSettingsService.getEstimateConfigurationAsync();
    this.selectedDepartment = await this.departmentPickerService.getDepartmentByCode(
      this.estimateSettings.defaultImportDepartmentCode
    );
  }

  public async selectDepartment(selectedDepartment: DepartmentPickerItem | undefined) {
    if (!this.estimateSettings) {
      return;
    }

    const code = selectedDepartment?.code;
    if (this.estimateSettings?.defaultImportDepartmentCode === code) {
      return;
    }

    this.estimateSettings.defaultImportDepartmentCode = code;

    await this.loadingService.run(async () => {
      await this.estimateSettingsService.setEstimateConfiguration(this.estimateSettings);
    });
  }
}
